import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useForm, Controller } from "react-hook-form";
import api from "../../../../utils/api";
import Swal from "sweetalert2";

const SipStartModal = ({
    show,
    defSIP,
    onHide,
    selectedStartSIPFund,
    generateSipLoading = false,
    isFiltered,
    roomId,
    clientGoalMain,
    getDraftGoalData
}) => {
    const {
        register,
        handleSubmit,
        control,
        watch,
        reset,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        defaultValues: {
            sipaction: "SIP",
            goalNameSIP: "",
            sipStartDate: null,
            sipAmountSIP: "",
            perpetualSIP: "",
            sipEndDate: null,
        },
    });

    const perpetualSIPW = watch("perpetualSIP");
    const sipAmountW = watch("sipAmountSIP");

    const [modalTitle, setModalTitle] = useState("");
    const [actionName, setActionName] = useState("Start SIP");
    const [submitting, setSubmitting] = useState(false);

    const selectedGoalData = clientGoalMain?.find(goal => goal._id === selectedStartSIPFund?.goal_id);
    console.log('selectedGoalData:', selectedGoalData, selectedStartSIPFund, clientGoalMain);
    

    const resetForm = () => {
        reset({
            sipaction: "SIP",
            goalNameSIP: "",
            sipStartDate: null,
            sipAmountSIP: "",
            perpetualSIP: "",
            sipEndDate: null,
        });
        clearErrors();
        setActionName("Start SIP");
    };

    const handleModalClose = () => {
        resetForm();
        onHide();
    };

    useEffect(() => {
        if (show && selectedStartSIPFund) {
            reset({
                sipaction: "SIP",
                goalNameSIP: selectedStartSIPFund?.goal_name || "",
                sipStartDate: null,
                sipAmountSIP: "",
                perpetualSIP: "",
                sipEndDate: null,
            });

            clearErrors();
        }
    }, [show, selectedStartSIPFund, reset, clearErrors]);

    useEffect(() => {
        if (sipAmountW) {
            setActionName(
                `Start a Monthly SIP of Rs. ${sipAmountW} for ${selectedStartSIPFund?.goal_name || ""
                }`
            );
        } else {
            setActionName("Start SIP");
        }
    }, [sipAmountW, selectedStartSIPFund]);

    useEffect(() => {
        if (selectedStartSIPFund?.fund_name) {
            let formattedFundName = selectedStartSIPFund.fund_name;

            if (formattedFundName.includes("Fund")) {
                formattedFundName = formattedFundName.substring(
                    0,
                    formattedFundName.indexOf("Fund") + 4
                );
            }

            const currentValue = Math.round(
                Number(selectedStartSIPFund?.aum_as_per_rta || 0)
            );

            setModalTitle(
                `${formattedFundName} (${selectedStartSIPFund?.folio_number || "-"
                }) | Current Value : ₹${currentValue}`
            );
        } else {
            setModalTitle("");
        }
    }, [selectedStartSIPFund]);



     const calculateDeficitAmount = (data) => {
        let monthEndValue = 0;
        let capitalGrowth = 0;
        let expectedReturn = parseInt(selectedGoalData?.goalPlanData?.expectedReturn);
        let sipAmount = parseInt(data.sipAmountSIP);
        let goalYear = parseInt(selectedGoalData?.goalPlanData?.goalYear);
        let initialTotalMonth = (goalYear - new Date().getFullYear()) * 12;
        if (data.perpetualSIP === "Yes"||data.perpetualSIP === "yes") {
            for (let i = 1; i < initialTotalMonth; i++) {
                capitalGrowth = ((monthEndValue + sipAmount) * expectedReturn) / 1200;
                monthEndValue = monthEndValue + capitalGrowth + sipAmount;
            }
            monthEndValue = monthEndValue + sipAmount;
        console.log('monthEndValue', monthEndValue, 'capitalGrowth', capitalGrowth,initialTotalMonth,goalYear,sipAmount,expectedReturn,);

        } else {
            let diff =
                (new Date(data.sipEndDate).getFullYear() -
                    new Date(data.sipStartDate).getFullYear()) *
                12 +
                new Date(data.sipEndDate).getMonth() -
                new Date(data.sipStartDate).getMonth();

            for (let i = 1; i < diff; i++) {
                capitalGrowth = ((monthEndValue + sipAmount) * expectedReturn) / 1200;
                monthEndValue = monthEndValue + capitalGrowth + sipAmount;
            }
            monthEndValue = monthEndValue + data.sipAmount;
        }

        console.log('monthEndValue', monthEndValue,data.perpetualSIP, capitalGrowth,initialTotalMonth,goalYear,sipAmount,expectedReturn,);
        
        // setDeficitAmount(Math.round(monthEndValue));
        return (Math.round(monthEndValue));
    };
   



    const latestUccMandate = async (panClientId) => {
    if (!panClientId) {
        throw new Error("PAN Client ID is missing");
    }

    try {
        const response = await api.get(
            `advisor/latest-ucc-mandate/${panClientId}`
        );

        console.log("response-3",response.data);
        

        return response?.data?.data || {};
    } catch (error) {
        console.error("Error fetching latest UCC mandate:", error);

        throw new Error(
            error?.response?.data?.message ||
            "Unable to fetch latest UCC mandate"
        );
    }
};

const onSubmit = async (data) => {
    clearErrors();
    setSubmitting(true);

    try {
        if (!selectedStartSIPFund?.pan_client_id) {
            setError("root.serverError", {
                type: "manual",
                message: "PAN Client ID is missing.",
            });
            return;
        }

        const sipDef = await calculateDeficitAmount(data);

        // const defSIP = calculateSIPDeficit(
        //     selectedGoalData?.accumulated,
        //     selectedGoalData?.goalPlanData
        // );

        const latestMandateData = await latestUccMandate(
            selectedStartSIPFund.pan_client_id
        );

        if (!latestMandateData?.latest_ucc) {
            setError("root.serverError", {
                type: "manual",
                message: "Latest UCC not found.",
            });
            return;
        }

        if (!latestMandateData?.latest_mandate) {
            setError("root.serverError", {
                type: "manual",
                message: "Latest mandate not found.",
            });
            return;
        }

        const payload = {
            scheme_code: selectedStartSIPFund?.scheme_code || "",
            fundName: selectedStartSIPFund?.fund_name || "",
            goalId: selectedStartSIPFund?.goal_id || "",
            subGoalId: selectedStartSIPFund?.sub_goal_id || "",
            staticTargetAmount:  selectedGoalData?.TargetAmount,
            client_id: selectedStartSIPFund?.client_id || "",
            goal_name: selectedStartSIPFund?.goal_name || "",

            ucc: latestMandateData.latest_ucc,
            mandateCode: latestMandateData.latest_mandate,
            mandateType: "XSP",

            folioNo: selectedStartSIPFund?.folio_number || "",
            email: selectedStartSIPFund?.email_id || "",
            mobile: selectedStartSIPFund?.mobile_number ? selectedStartSIPFund?.mobile_number.replace("+91", "") : "",
            accountNo: selectedStartSIPFund?.account_number || "",
            ifsc_code: selectedStartSIPFund?.ifsc_code || "",

            sipDeficit: Number(sipDef || 0),
            defSIP: Number(defSIP || 0),

            goalYear: selectedStartSIPFund?.goal_year || "2025",
            sipAmt: Number(data?.sipAmountSIP || 0),
            perpetual: data?.perpetualSIP ? data?.perpetualSIP.charAt(0).toUpperCase() + data?.perpetualSIP.slice(1) : "No",

            startDate: data?.sipStartDate
                ? data.sipStartDate.toISOString()
                : "",

            endDate: data?.sipEndDate
                ? data.sipEndDate.toISOString()
                : "",

            isStepUp: "No",
            stepUpAmt: null,
            stepUpImpact: 0,

            investorName: selectedStartSIPFund?.investor_name || "",
            productCode: selectedStartSIPFund?.product_code || "",
            member_id: selectedStartSIPFund?.pan_client_id?.toString() || "",
        };
        // console.log("SIP Start Payload:", payload);
        // return
        const response = await api.post(`advisor/sip_start`, payload);

        if (response?.data?.status === false) {
            setError("root.serverError", {
                type: "server",
                message:
                    response?.data?.message ||
                    "Unable to start SIP. Please check details.",
            });
            return;
        }

        await Swal.fire({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "SIP started successfully.",
            confirmButtonColor: "#3085d6",
            timer: 2000,
            showConfirmButton: false,
        });

        await getDraftGoalData();

        resetForm();
        onHide();

    } catch (error) {
        console.error("Error starting SIP:", error);

        setError("root.serverError", {
            type: "server",
            message:
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.",
        });
    } finally {
        setSubmitting(false);
    }
};
   

   

    return (
        <Modal
            show={show}
            onHide={handleModalClose}
            centered
            aria-labelledby="sipStartModal"
        >
            <Modal.Header closeButton>
                <p className="fs-6 fw-bold m-0">{modalTitle}</p>
            </Modal.Header>

            {generateSipLoading ? (
                <Modal.Body className="d-flex align-items-center justify-content-center py-5">
                    <div className="spinner-border text-success" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </Modal.Body>
            ) : (
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Modal.Title
                            id="sipStartModal"
                            style={{
                                fontSize: "16px",
                                backgroundColor: "#23674B",
                                color: "#fff",
                                marginBottom: 20,
                                padding: "10px",
                                borderRadius: "10px",
                                textAlign: "center",
                            }}
                        >
                            {actionName}
                        </Modal.Title>

                        {errors.root?.serverError && (
                            <div className="alert alert-danger py-2">
                                {errors.root.serverError.message}
                            </div>
                        )}

                        <Form.Group className="mb-3">
                            <Form.Label>Action</Form.Label>
                            <Form.Select
                                {...register("sipaction", {
                                    required: "Please select action.",
                                    onChange: () => clearErrors("sipaction"),
                                })}
                            >
                                <option value="SIP">SIP</option>
                            </Form.Select>

                            {errors.sipaction && (
                                <small className="text-danger">
                                    {errors.sipaction.message}
                                </small>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Goal Name</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                {...register("goalNameSIP", {
                                    required: "Goal Name is required.",
                                    onChange: () => clearErrors("goalNameSIP"),
                                })}
                            />

                            {errors.goalNameSIP && (
                                <small className="text-danger">
                                    {errors.goalNameSIP.message}
                                </small>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>SIP Start Date</Form.Label>
                            <Controller
                                name="sipStartDate"
                                control={control}
                                rules={{ required: "SIP Start Date is required." }}
                                render={({ field }) => (
                                    <DatePicker
                                        className="form-control w-100"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select SIP Start Date"
                                        selected={field.value}
                                        onChange={(date) => {
                                            field.onChange(date);
                                            clearErrors("sipStartDate");
                                        }}
                                        minDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                )}
                            />

                            {errors.sipStartDate && (
                                <small className="text-danger">
                                    {errors.sipStartDate.message}
                                </small>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>SIP Amount</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter SIP Amount"
                                {...register("sipAmountSIP", {
                                    required: "SIP Amount is required.",
                                    min: {
                                        value: 1,
                                        message: "Amount must be at least 1.",
                                    },
                                    onChange: () => clearErrors("sipAmountSIP"),
                                })}
                            />

                            {errors.sipAmountSIP && (
                                <small className="text-danger">
                                    {errors.sipAmountSIP.message}
                                </small>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Perpetual SIP?</Form.Label>
                            <Form.Select
                                {...register("perpetualSIP", {
                                    required: "Perpetual SIP is required.",
                                    onChange: () => {
                                        clearErrors("perpetualSIP");
                                        clearErrors("sipEndDate");
                                    },
                                })}
                            >
                                <option value="">Select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>

                            {errors.perpetualSIP && (
                                <small className="text-danger">
                                    {errors.perpetualSIP.message}
                                </small>
                            )}
                        </Form.Group>

                        {perpetualSIPW === "no" && (
                            <Form.Group className="mb-3">
                                <Form.Label>SIP End Date</Form.Label>
                                <Controller
                                    name="sipEndDate"
                                    control={control}
                                    rules={{
                                        required:
                                            perpetualSIPW === "no"
                                                ? "SIP End Date is required."
                                                : false,
                                    }}
                                    render={({ field }) => (
                                        <DatePicker
                                            className="form-control w-100"
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Select SIP End Date"
                                            selected={field.value}
                                            onChange={(date) => {
                                                field.onChange(date);
                                                clearErrors("sipEndDate");
                                            }}
                                            minDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                    )}
                                />

                                {errors.sipEndDate && (
                                    <small className="text-danger">
                                        {errors.sipEndDate.message}
                                    </small>
                                )}
                            </Form.Group>
                        )}

                        <Button
                            variant="success"
                            type="submit"
                            className="w-100"
                            disabled={submitting}
                        >
                            {submitting ? "Updating..." : "Update"}
                        </Button>
                    </Form>
                </Modal.Body>
            )}
        </Modal>
    );
};



export default SipStartModal;



    function calculateSIPDeficit(accumulated, goal) {
  if (goal.monthlysaving) {
    const currentTime = new Date();
    const targetYear = Number(goal.targetYear || 0);
    let startYear = 0;

    if (goal?.yearLeftText === "Goal Timeline (Years)") {
      startYear = goal.startYear;
    } else {
      startYear = new Date().getFullYear();
    }
    const monthsLeft = (targetYear - startYear) * 12;

    const targetAmount = Number(goal.targetAmount || 0);
    const staticCAGR = Number(goal.targetReturn || 0);
    const timeline = Number(goal.timeline || monthsLeft / 12);
    let runningSIP = Number(goal.runningSIP || 0);
    const accumulatedVal = Number(accumulated || 0);

    const sipForTarget = calculateMonthlySIP(
      targetAmount,
      staticCAGR,
      timeline,
    );

    const testMonths = (targetYear - currentTime.getFullYear()) * 12;

    if (runningSIP !== 0 || accumulatedVal !== 0) {
      let monthEndVal = 0;

      for (let i = 1; i < testMonths; i++) {
        const capitalGrow = ((monthEndVal + runningSIP) * staticCAGR) / 1200;
        monthEndVal += capitalGrow + runningSIP;
      }

      monthEndVal += runningSIP;

      const accumFutureVal =
        accumulatedVal *
        Math.pow(1 + staticCAGR / 100, targetYear - currentTime.getFullYear());

      const futureVal = Math.round(monthEndVal) + accumFutureVal;
      const remainingVal = targetAmount - futureVal;

      const requiredSIP =
        (remainingVal * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, testMonths) - 1);

      // 🧾 Clean logging line
      console.log(
        `🧾 SIP Calc → Target: ₹${targetAmount}, Accum: ₹${accumulatedVal}, Start: ${startYear}, Target: ${targetYear}, MonthsLeft: ${monthsLeft}, CAGR: ${staticCAGR}%, RunningSIP: ₹${runningSIP}, SIP(Target): ₹${sipForTarget.toFixed(
          2,
        )}, FutureVal: ₹${futureVal.toFixed(
          2,
        )}, Remaining: ₹${remainingVal.toFixed(
          2,
        )}, RequiredSIP: ₹${requiredSIP.toFixed(2)}`,
      );

      return requiredSIP;
    } else {
      return 0;
    }
  }
}

function calculateMonthlySIP(targetAmount, annualReturn, timelineYears) {
  const months = timelineYears * 12; // Convert years to months
  const monthlyRate = annualReturn / 12 / 100; // Convert annual return to monthly

  // Future Value Annuity Formula
  const factor = Math.pow(1 + monthlyRate, months) - 1;

  // Avoid division by zero error
  if (factor <= 0) return targetAmount / months;

  const monthlySIP = (targetAmount * monthlyRate) / factor;

  return monthlySIP;
}